module.exports = __webpack_public_path__ + "static/media/Rightarrow.e227881e.svg";